<div class="MessageModal">
    <mat-toolbar>
        <h3>{{'selectTemplate'| translate}}</h3>
    </mat-toolbar>

    <mat-dialog-content>
        <p class="subtitle">
            {{'selectTemplateSubtitle'| translate}}
        </p>

        <mat-form-field appearance="outline" class="location-select">
            <mat-label>{{ 'selectLocation' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedLocation" (selectionChange)="validateSelection()">
                <mat-option *ngFor="let location of locationList" [value]="location.value">
                    {{ location.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        

        <!-- <mat-checkbox [(ngModel)]="selectAll" (change)="toggleAll(); validateSelection()">
            {{'selectAll'| translate}}
        </mat-checkbox> -->

        <div class="checkbox-list">
            <mat-checkbox [(ngModel)]="selectedItems['ProductStorageLocations']" (change)="validateSelection()">
                {{'storages'| translate}}
            </mat-checkbox>
            <!-- <mat-checkbox [(ngModel)]="selectedItems['ProductCategories']" (change)="validateSelection()">
                {{'categories'| translate}}
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedItems['ProductCountMethods']" (change)="validateSelection()">
                {{'countTypeMethods'| translate}}
            </mat-checkbox>
            <mat-checkbox [(ngModel)]="selectedItems['ProductBarcodes']" (change)="validateSelection()">
                {{'barcodes'| translate}}
            </mat-checkbox> -->
        </div>
    </mat-dialog-content>

    <mat-dialog-actions style="float:right">
        <button mat-dialog-close mat-button mat-raised-button color="accent" (click)="saveSelection()" [disabled]="!isValidSelection">
            {{ "select" | translate }}
        </button>
    </mat-dialog-actions>
</div>
